import { trackAction, trackEvent } from './helpers';

export const trackDismissRecommendation = (companyId: $TSFixMe) =>
  trackAction('companies_reco_delete_click', {
    PropItemId: `companies_${companyId}`,
  });

export const trackFollowCompany = (companyId: $TSFixMe) =>
  trackEvent('EventFollow', 'companies_follow', {
    PropItemId: `companies_${companyId}`,
  });

export const trackUnfollowCompany = (companyId: $TSFixMe) =>
  trackEvent('EventUnfollow', 'companies_unfollow', {
    PropItemId: `companies_${companyId}`,
  });

export const trackViewMoreRecommendedCompanies = ({ userIsEditor }: $TSFixMe) =>
  trackAction('companies_other_interesting_companies_click', {
    PropContextDimension3: userIsEditor ? 'companies_editor' : 'companies_user',
  });
